module.exports = __webpack_public_path__ + "static/media/Claim-icon-3.99f6e78a.svg";